import React, { useState, useEffect, useRef } from "react";
import { FaLinkedin, FaTwitter, FaGithub, FaFileAlt, FaArrowRight, FaUserTie } from "react-icons/fa";
import avatar1 from "../assets/avatar1.jpg";

// ক্যানভাস অ্যাভাটার কম্পোনেন্ট
const CanvasAvatar = ({ name, title, isDarkMode }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let animationFrameId;
    let hue = 0;

    const drawAvatar = () => {
      const width = canvas.width;
      const height = canvas.height;

      ctx.clearRect(0, 0, width, height);

      // গ্রেডিয়েন্ট ব্যাকগ্রাউন্ড
      const gradient = ctx.createLinearGradient(0, 0, width, height);
      gradient.addColorStop(0, `hsl(${hue}, 70%, 60%)`);
      gradient.addColorStop(1, `hsl(${hue + 40}, 70%, 50%)`);
      
      ctx.fillStyle = gradient;
      ctx.beginPath();
      ctx.rect(0, 0, width, height);
      ctx.fill();

      // নামের প্রথম অক্ষর
      ctx.font = "bold 48px Arial";
      ctx.fillStyle = "white";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(name.charAt(0), width/2, height/2);

      // ছোট ছোট ডেকোরেটিভ সার্কেল
      for (let i = 0; i < 5; i++) {
        ctx.beginPath();
        ctx.arc(
          width * (0.2 + i * 0.15), 
          height * 0.8, 
          3, 
          0, 
          Math.PI * 2
        );
        ctx.fillStyle = `rgba(255, 255, 255, ${0.3 + i * 0.1})`;
        ctx.fill();
      }

      hue = (hue + 1) % 360;
      animationFrameId = requestAnimationFrame(drawAvatar);
    };

    drawAvatar();

    return () => cancelAnimationFrame(animationFrameId);
  }, [name]);

  return (
    <canvas
      ref={canvasRef}
      width={160}
      height={160}
      style={{
        width: "100%",
        height: "100%",
        display: "block",
      }}
    />
  );
};

// ক্রস করা আইকন কম্পোনেন্ট
const CrossedIcon = ({ icon: Icon, color }) => {
  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Icon style={{ color, fontSize: "22px", opacity: 0.4 }} />
      <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(45deg)",
        width: "24px",
        height: "2px",
        backgroundColor: "#FF4444",
        borderRadius: "2px",
      }} />
      <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%) rotate(-45deg)",
        width: "24px",
        height: "2px",
        backgroundColor: "#FF4444",
        borderRadius: "2px",
      }} />
    </div>
  );
};

const OurTeam = ({ isDarkMode }) => {
  const [showHirePopup, setShowHirePopup] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);
  
  const textColor = isDarkMode ? "#f1f5f9" : "#111";
  const subTextColor = isDarkMode ? "#94a3b8" : "#333";
  const cardBg = isDarkMode ? "rgba(30, 41, 59, 0.5)" : "rgba(255, 255, 255, 0.1)";
  const cardBorder = isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(255,255,255,0.2)";

  // Scroll to contact section function
  // Scroll to contact section function - FIXED
  const scrollToContact = () => {
    setShowHirePopup(false);
    
    // Small delay to ensure popup closes before scrolling
    setTimeout(() => {
      // Try to find contact section by multiple possible IDs
      const contactSection = document.getElementById("contactus") || 
                            document.getElementById("contact") || 
                            document.getElementById("contact-us");
      
      if (contactSection) {
        contactSection.scrollIntoView({ 
          behavior: "smooth",
          block: "start"
        });
      } else {
        // If not found on current page, navigate to home page with hash
        window.location.href = "/#contactus";
      }
    }, 100);
  };

  const handleHireClick = (member) => {
    setSelectedMember(member);
    setShowHirePopup(true);
  };

  const teamMembers = [
    {
      name: "MD SHAFIUL ALAM",
      title: "Lead of Operations & Developer",
      img: avatar1,
      linkedin: "https://linkedin.com/in/shafiulalam",
      twitter: "https://twitter.com/shafiulalam",
      github: "https://github.com/shafiulalam",
      cv: "/cv",
      isActive: true,
    },
    {
      name: "Alice Johnson",
      title: "Lead Developer",
      img: null,
      linkedin: null,
      twitter: null,
      github: null,
      cv: "#",
      isActive: false,
    },
    {
      name: "Bob Smith",
      title: "Creative Director",
      img: null,
      linkedin: null,
      twitter: null,
      github: null,
      cv: "#",
      isActive: false,
    },
  ];

  return (
    <>
      {/* Hire Now Popup Modal */}
      {showHirePopup && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.6)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            padding: "20px",
            animation: "fadeIn 0.3s ease-out",
          }}
          onClick={() => setShowHirePopup(false)}
        >
          <div
            style={{
              background: isDarkMode ? "#1e293b" : "#ffffff",
              borderRadius: "24px",
              padding: "40px",
              maxWidth: "450px",
              width: "100%",
              position: "relative",
              boxShadow: "0 25px 50px -12px rgba(0,0,0,0.25)",
              textAlign: "center",
              animation: "slideUp 0.3s ease-out",
              border: `1px solid ${isDarkMode ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.05)"}`,
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setShowHirePopup(false)}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                background: "none",
                border: "none",
                fontSize: "28px",
                cursor: "pointer",
                color: isDarkMode ? "#94a3b8" : "#666",
                transition: "color 0.3s ease",
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = "#FF4444"}
              onMouseLeave={(e) => e.currentTarget.style.color = isDarkMode ? "#94a3b8" : "#666"}
            >
              ×
            </button>

            {/* Icon */}
            <div
              style={{
                width: "80px",
                height: "80px",
                background: "linear-gradient(135deg, #FF4444, #FF6B6B)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                boxShadow: "0 10px 25px rgba(255,68,68,0.3)",
              }}
            >
              <FaUserTie size={40} color="#fff" />
            </div>

            {/* Title */}
            <h2
              style={{
                fontSize: "28px",
                marginBottom: "12px",
                color: isDarkMode ? "#fff" : "#1a1f36",
                fontWeight: "bold",
              }}
            >
              {selectedMember?.name || "Hire a Professional"}
            </h2>

            {/* Message */}
            <p
              style={{
                fontSize: "16px",
                lineHeight: "1.6",
                color: isDarkMode ? "#cbd5e1" : "#4a5568",
                marginBottom: "25px",
              }}
            >
              Thank you for your interest in hiring{' '}
              <strong style={{ color: "#FF4444" }}>
                {selectedMember?.name || "our team member"}
              </strong>
              . To proceed with the hiring process, please scroll down to the 
              <strong style={{ color: "#FF4444" }}> Contact Section</strong> and 
              connect with our team. We'll be happy to discuss your requirements 
              and provide you with the best solution tailored to your needs.
            </p>

            {/* Divider */}
            <div
              style={{
                height: "1px",
                background: isDarkMode ? "rgba(255,255,255,0.1)" : "#e2e8f0",
                margin: "20px 0",
              }}
            />

            {/* Action Buttons */}
            <div
              style={{
                display: "flex",
                gap: "15px",
                justifyContent: "center",
                flexWrap: "wrap",
              }}
            >
              <button
                onClick={scrollToContact}
                style={{
                  padding: "12px 32px",
                  borderRadius: "40px",
                  border: "none",
                  background: "linear-gradient(135deg, #FF4444, #FF6B6B)",
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  transition: "all 0.3s ease",
                  boxShadow: "0 5px 15px rgba(255,68,68,0.3)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 10px 25px rgba(255,68,68,0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 5px 15px rgba(255,68,68,0.3)";
                }}
              >
                Go to Contact
                <FaArrowRight size={14} />
              </button>

              <button
                onClick={() => setShowHirePopup(false)}
                style={{
                  padding: "12px 32px",
                  borderRadius: "40px",
                  border: `2px solid ${isDarkMode ? "#FF4444" : "#FF4444"}`,
                  background: "transparent",
                  color: isDarkMode ? "#FF4444" : "#FF4444",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = "#FF4444";
                  e.currentTarget.style.color = "#fff";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = isDarkMode ? "#FF4444" : "#FF4444";
                }}
              >
                Cancel
              </button>
            </div>

            {/* Help Text */}
            <p
              style={{
                fontSize: "12px",
                color: isDarkMode ? "#64748b" : "#a0aec0",
                marginTop: "20px",
                marginBottom: 0,
              }}
            >
              Our team typically responds within 24 hours
            </p>
          </div>
        </div>
      )}

      {/* CSS Animations */}
      <style>
        {`
          @keyframes fadeIn {
            from {
              opacity: 0;
            }
            to {
              opacity: 1;
            }
          }

          @keyframes slideUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      <section
        id="ourteam"
        style={{
          padding: "80px 20px",
          textAlign: "center",
          background: "transparent",
          position: "relative",
          zIndex: 1,
        }}
      >
        <h2 style={{ fontSize: "42px", marginBottom: "10px", color: textColor }}>Our Team</h2>
        <p style={{ marginBottom: "50px", opacity: 0.8, color: subTextColor }}>
          Meet the leadership behind our projects
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px,1fr))",
            gap: "30px",
            maxWidth: "1200px",
            margin: "auto",
          }}
        >
          {teamMembers.map((member, index) => (
            <div
              key={index}
              style={{
                background: cardBg,
                backdropFilter: "blur(10px)",
                borderRadius: "20px",
                padding: "30px 20px",
                boxShadow: isDarkMode 
                  ? "0 10px 25px rgba(0,0,0,0.3)" 
                  : "0 10px 25px rgba(0,0,0,0.1)",
                textAlign: "center",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
                cursor: "pointer",
                border: `1px solid ${cardBorder}`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-10px)";
                e.currentTarget.style.boxShadow = isDarkMode 
                  ? "0 15px 30px rgba(0,0,0,0.4)" 
                  : "0 15px 30px rgba(0,0,0,0.15)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = isDarkMode 
                  ? "0 10px 25px rgba(0,0,0,0.3)" 
                  : "0 10px 25px rgba(0,0,0,0.1)";
              }}
            >
              <div
                style={{
                  width: "160px",
                  height: "160px",
                  margin: "0 auto 15px",
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
                  border: "3px solid rgba(255,255,255,0.3)",
                }}
              >
                {member.img ? (
                  <img
                    src={member.img}
                    alt={member.name}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <CanvasAvatar name={member.name} title={member.title} isDarkMode={isDarkMode} />
                )}
              </div>
              
              <h3 style={{ marginBottom: "5px", fontSize: "20px", color: textColor }}>
                {member.name}
              </h3>
              
              <p style={{ marginBottom: "15px", fontSize: "14px", color: subTextColor, fontWeight: 500 }}>
                {member.title}
              </p>
              
              {/* সোশ্যাল মিডিয়া এবং CV আইকন */}
              <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                gap: "15px",
                marginBottom: "20px",
                alignItems: "center"
              }}>
                {member.isActive ? (
                  <>
                    {member.linkedin && (
                      <a
                        href={member.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#0A66C2", fontSize: "22px", transition: "transform 0.2s" }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                      >
                        <FaLinkedin />
                      </a>
                    )}
                    {member.twitter && (
                      <a
                        href={member.twitter}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#1DA1F2", fontSize: "22px", transition: "transform 0.2s" }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                      >
                        <FaTwitter />
                      </a>
                    )}
                    {member.github && (
                      <a
                        href={member.github}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: isDarkMode ? "#fff" : "#333", fontSize: "22px", transition: "transform 0.2s" }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                      >
                        <FaGithub />
                      </a>
                    )}
                  </>
                ) : (
                  <>
                    <CrossedIcon icon={FaLinkedin} color="#0A66C2" />
                    <CrossedIcon icon={FaTwitter} color="#1DA1F2" />
                    <CrossedIcon icon={FaGithub} color={isDarkMode ? "#fff" : "#333"} />
                  </>
                )}
                
                {/* CV আইকন - সবার জন্য */}
                {member.cv && (
                  <a
                    href={member.cv}
                    style={{ color: "#FF4444", fontSize: "22px", transition: "transform 0.2s" }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                  >
                    <FaFileAlt />
                  </a>
                )}
              </div>

              {/* Hire Now বাটন */}
              <button
                onClick={() => handleHireClick(member)}
                style={{
                  padding: "8px 24px",
                  borderRadius: "25px",
                  border: "none",
                  background: "linear-gradient(135deg, #FF4444, #FF6666, #FF8888)",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 4px 12px rgba(255, 68, 68, 0.3)",
                  letterSpacing: "0.5px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = "0 6px 16px rgba(255, 68, 68, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 68, 68, 0.3)";
                }}
              >
                Hire Now
              </button>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default OurTeam;